export default __webpack_public_path__ + "static/C3-popup-Vakantie_Kerst-2024-cda27461b58848b888c4152ddd245bd8.png";